<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <v-card elevation="0">
                                <v-card-text class="d-flex flex-column ga-1">
                                    <div>Faculty Name: <span class="font-weight-bold">{{ getItemTitle(mentoringData.faculty) }}</span></div>
                                    <div>Mentoring Date: <span class="font-weight-bold">{{ formatDate(mentoringData.mentoring_date) }}</span></div>
                                    <div>Closeout Date: <span class="font-weight-bold">{{ formatDate(mentoringData.closeout_date) }}</span></div>
                                    <div>Office: <span class="font-weight-bold">{{ mentoringData.office.name }}</span></div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col class="text-right mt-md-10" cols="12" md="6">
                            <v-btn
                            v-if="data.length > 0"
                            @click="printMentoring()"
                            prepend-icon="mdi-printer"
                            class="mt-1 rounded-lg"
                            color="deep-orange-darken-1"
                            height="40px"
                            elevation="2">
                                Print Mentoring
                            </v-btn>
                            <v-btn
                                v-if="mentoringData.file"
                                @click="showViewFileDialog(mentoringData.file)"
                                prepend-icon="mdi-file-pdf-box"
                                class="mt-1 rounded-lg ml-md-2"
                                color="indigo-darken-1"
                                height="40px"
                                elevation="2">
                                View Attachment
                            </v-btn>
                        </v-col>
                        <v-col cols="12">
                            <v-card class="dt-container" elevation="1">
                                <v-card-text>
                                    <div class="d-flex flex-column flex-md-row align-md-center justify-space-between ga-3">
                                        <div>
                                            <div class="font-weight-bold">Upload Mentoring Memo Attachment</div>
                                            <div class="text-caption">This file belongs to the mentoring record.</div>
                                        </div>
                                        <div class="d-flex align-center ga-2 flex-wrap">
                                            <v-file-input
                                                v-model="attachmentFile"
                                                accept="application/pdf"
                                                label="Upload PDF"
                                                hide-details
                                                clearable
                                                density="comfortable"
                                                variant="outlined"
                                                prepend-inner-icon="mdi-file-pdf-box"
                                                class="attachment-file-input"
                                                style="min-width: 600px;"
                                            />
                                        </div>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12">
                            <v-card class="dt-container">    
                                <v-data-table
                                    :mobile="isMobileOrTablet()"
                                    :headers="headers"
                                    :items="data"
                                    :loading="loading"
                                    :items-per-page="15"
                                    :items-per-page-options="[15,30, 50, 100, -1]"
                                >
                                <template v-slot:loading>
                                    <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                                </template>
                                <template v-slot:item.found_date="{ item }">
                                    <span>{{ formatDate(item.found_date) }} </span>
                                </template>
                                <template v-slot:[`item.file`]="{ item }">
                                    <v-btn
                                        v-if="item.file"
                                        @click="showViewFileDialog(item.file)"
                                        size="x-small"
                                        variant="outlined"
                                        color="indigo-darken-1"
                                        prepend-icon="mdi-file-pdf-box"
                                    >
                                        View
                                    </v-btn>
                                </template>
                                </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="uploadingAttachment" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="saveMentoring()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="confirmDel" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want to remove this mentoring details?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, The action cannot be reversible..</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmDel = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="deleteMentoringDetail()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <mentoring-details-sub-dialog ref="mentoringDetailsSubDialog" @refresh="initView(mentoringData)"></mentoring-details-sub-dialog>
    <ViewFileDialog ref="ViewFileDialog" />
</template>

<script>
import { defineComponent } from 'vue'
import MentoringDetailsSubDialog from './Sub-Dialogs/MentoringDetailsSubDialog.vue';
import ViewFileDialog from './Sub-Dialogs/ViewFileDialog.vue';
import { useSnackbar } from '@/composables/useSnackbar';
import { generateMentoringPDF } from '@/composables/pdf/mentoring-pdf.js';

export default defineComponent({
     emits: ["refresh"],
     components: {
        MentoringDetailsSubDialog,
        ViewFileDialog
     },
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,
            headers: [
                { title: 'Concern', align: 'start', sortable: true, key: 'concern' },
                { title: 'Date Identified', align: 'start', sortable: true, key: 'found_date' },
                { title: 'Coaching/Mentoring Description/Recommendation', align: 'start', sortable: true, key: 'recommendation' },
                { title: 'Faculty Commitment', align: 'start', sortable: true, key: 'commitment' },
                { title: 'Timeline', align: 'start', sortable: true, key: 'timeline' },
                { title: 'Remarks/Date', align: 'start', sortable: true, key: 'remarks' },
                { title: 'Attachment', align: 'center', sortable: false, key: 'file' },
            ],

            data: [],
            mentoringData: [],
            attachmentFile: null,
            uploadingAttachment: false,
            confirmDel: false,
            toBeDeletedItem: null,
        }
     },
     methods: {
        initView(data){
            this.dialog = true
            this.dialog_title = 'View Mentoring'
            this.dialog_sub_title = 'View mentoring information'
            this.action = 'view'

            this.mentoringData = data
            this.initDetails()
        },
        async initDetails(){
            let res = await this.axiosCall('/mentoring-details/findAllByMentoring/' + this.mentoringData.id, 'get', null, true)
            if(res.data){
                this.data = res.data
            }
        },
        async deleteMentoringDetail(){
            const { showSnackbar } = useSnackbar()
            this.loading = true
            let res = await this.axiosCall('/mentoring-details/' + this.toBeDeletedItem.id, 'delete', null, true)
            if(res.data){
                showSnackbar('Mentoring details successfully removed.')
                this.initDetails()
            }
            this.loading = false
            this.confirmDel = false
        },
        getItemTitle(item) {
            return `${item.fname} ${item.mname ? item.mname[0] + '.' :''} ${item.lname}${item.suffix ? ', ' + item.suffix : ''}` ;
        },
        async saveMentoring(){
            if (!this.attachmentFile) {
                this.closeDialog()
                return
            }
            await this.uploadAttachment()
        },
        async uploadAttachment(){
            if (!this.mentoringData?.id) {
                return
            }

            const selectedFile = Array.isArray(this.attachmentFile) ? this.attachmentFile[0] : this.attachmentFile
            const formData = new FormData()
            formData.append('file', selectedFile)

            this.uploadingAttachment = true
            const res = await this.axiosCall('/mentoring/' + this.mentoringData.id, 'patch', formData, true)

            if (res.data?.status === 200) {
                this.mentoringData.file = res.data.file || selectedFile.name
                this.attachmentFile = null
                this.dialog = false
                this.$emit('refresh')
                const { showSnackbar } = useSnackbar()
                showSnackbar('Mentoring PDF saved successfully.')
            }

            this.uploadingAttachment = false
        },
        printMentoring(){
            generateMentoringPDF(this.mentoringData, this.data, this.$store.state.user.office.name)
        },
        showViewFileDialog(file) {
            this.$refs.ViewFileDialog.viewFile(file)
        },
        closeDialog(){
            this.$refs.form.reset()
            this.$emit('refresh')
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>